export default __webpack_public_path__ + "components/weather-icon/static/daysnowshowers@2-f9fcfdb19745839f39f528562e086f2b.png";